'use strict';

/* eslint no-undef: "off" */
/**
 * XPark community posts
 */
define('xparkCommunityPosts',['xparkHomepageApi'], function (xparkHomepageApi) {
  return {
    template: '\n      <section class="xp-community-posts" v-if="hasContent || loading">\n        <div v-if="loading" class="skeleton-loading"></div>\n        <div v-if="hasContent">\n          <h2>Infinix Community</h2>\n\n          <div class="xp-community-body">\n            <div class="xp-community-banner">\n              <img :src="banner.image" alt="" />\n              <span class="xp-community-banner-shade"></span>\n              <div class="xp-community-banner-content">\n                <p v-if="banner.text" v-text="banner.text"></p>\n                <a\n                  class="xp-community-join"\n                  v-if="banner.url"\n                  :href="banner.url"\n                >Join Now</a>\n              </div>\n            </div>\n\n            <div class="xp-community-grid">\n              <div\n                v-for="(column, columnIndex) in postColumns"\n                :key="columnIndex"\n                class="xp-community-column"\n              >\n                <a\n                  v-for="post in column"\n                  :key="post.url + post.created_at"\n                  class="xp-community-card"\n                  :class="\'xp-community-card-\' + (post.cardIndex + 1)"\n                  :href="post.url"\n                >\n                  <span class="xp-community-card-image">\n                    <img :src="post.image" alt="" />\n                  </span>\n                  <strong v-text="post.title"></strong>\n                  <span class="xp-community-author">\n                    <img :src="post.avatar" alt="" />\n                    <span v-text="post.username"></span>\n                  </span>\n                  <time v-text="post.created_at"></time>\n                </a>\n              </div>\n            </div>\n\n            <a\n              v-if="moreUrl"\n              class="xp-community-more"\n              :href="moreUrl"\n            >Show More</a>\n          </div>\n        </div>\n      </section>\n    ',
    data: function data() {
      return {
        banner: {},
        posts: [],
        moreUrl: '',
        loading: false
      };
    },

    computed: {
      hasContent: function hasContent() {
        return !!(this.banner.image && this.posts.length);
      },
      postColumns: function postColumns() {
        return [this.posts.filter(function (post, index) {
          return index % 2 === 0;
        }), this.posts.filter(function (post, index) {
          return index % 2 === 1;
        })];
      }
    },
    mounted: function mounted() {
      this.fetchCommunityPosts();
    },

    methods: {
      fetchCommunityPosts: function fetchCommunityPosts() {
        var _this = this;

        this.loading = true;
        xparkHomepageApi.getInfinixCommunity({
          page: 1,
          pageSizee: 4
        }).then(function (data) {
          var source = data || {};
          var banner = source.banner || {};
          var posts = source.posts && Array.isArray(source.posts.lists) ? source.posts.lists : [];

          _this.banner = banner;
          _this.moreUrl = source.more_url || source.more_link_url || source.moreUrl || source.more || '';
          _this.posts = posts.slice(0, 4).map(function (post, index) {
            return Object.assign({}, post, {
              cardIndex: index
            });
          });
        }).catch(function () {}).finally(function () {
          return _this.loading = false;
        });
      }
    }
  };
});
